import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: reduce ? 0 : y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.75, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
};

export const Eyebrow = ({ children, dark = false }) => (
    <p
        className={`mb-4 flex items-center gap-3 text-base font-bold uppercase tracking-[0.18em] ${
            dark ? "text-brand-amber" : "text-teal-800"
        }`}
    >
        <span className="h-[3px] w-10 rounded-full bg-brand-amber" aria-hidden="true" />
        {children}
    </p>
);

export const SectionHead = ({ eyebrow, title, dark = false, className = "" }) => (
    <div className={className}>
        <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
        <h2
            className={`font-display text-4xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl ${
                dark ? "text-cream" : "text-ink"
            }`}
        >
            {title}
        </h2>
    </div>
);